import { Component, input, output, TemplateRef } from '@angular/core';
import { ComponentSharedModule } from '@app/modules/component.shared.module';
import {
  MobiUiIconComponent,
  MobiUiLoadingIndicatorComponents,
} from '@mobi/rwc-ui-components-ng-jslib';
import { ViewRow } from '@app/models/view.model';

@Component({
  selector: 'mobi-view-results',
  standalone: true,
  imports: [ComponentSharedModule, MobiUiIconComponent, MobiUiLoadingIndicatorComponents],
  templateUrl: './view-results.component.html',
  styleUrls: ['./view-results.component.scss'],
})
export class ViewResultsComponent {
  readonly results = input.required<TemplateRef<any>>();
  readonly rows = input<ViewRow[]>([]);
  readonly loading = input(false);
  readonly loadingMore = input(false);
  readonly hasPagination = input(false);

  readonly loadNext = output<void>();
}
